// extracted by mini-css-extract-plugin
export default {"container":"ConsolidatedLoans_container__6B-2t"};